export enum EstateItemType {
    REVOCABLE_TRUST = "Revocable Trust",
    IRREVOCABLE_TRUST = "Irrevocable Trust",
    WILL = "Will",
    MISCELLANEOUS = "Miscellaneous"
}